// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N5OQsj_4Fb45opPpmMn4{margin-top:24px;margin-bottom:24px}.yu0OpHVb9gQshDYfdiTY{margin-left:-6px;margin-right:-6px;padding:12px 18px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `N5OQsj_4Fb45opPpmMn4`,
	"tabs": `yu0OpHVb9gQshDYfdiTY`
};
export default ___CSS_LOADER_EXPORT___;
